export default __webpack_public_path__ + "static/media/doorscratchafter.c08b819e.jpg";